import { Platform } from 'react-native';
import { Configuration, V0alpha2Api } from '@ory/kratos-client';
import { getEnvValue } from './getEnvValue';

export const kratosConfig = {
  host: getEnvValue('REACT_APP_KRATOS_URL')
};
export class KratosIntegration {
  request = new V0alpha2Api(
    new Configuration({
      basePath: kratosConfig.host,
      baseOptions: {
        timeout: 5000,
        withCredentials: Platform.OS === 'web'
      }
    })
  );
}

export const kratosIntegration = new KratosIntegration();
